
  import { RequiredConfigVariable } from '@/services/integrations/types';
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { Button } from '@/ui/components/Button';
  import { InputField } from '@/ui/components/form';
  import BaseStep, { BaseStepProperties, BASE_STEP_PROPS } from './BaseStep.vue';
  import { computed, defineComponent, ref } from 'vue';

  interface DropdownStepProperties extends BaseStepProperties {
    configVariable: RequiredConfigVariable;
  }

  export default defineComponent<DropdownStepProperties>({
    components: {
      InputField,
      Button,
      BaseStep,
    },
    props: [...BASE_STEP_PROPS, 'configVariable'],

    setup(props) {
      const { key } = props.configVariable;
      const store = useIntegrationDetailsStore();
      const username = props.configVariable.connection.inputs.nodes.find(input => input.key === 'username');
      const password = props.configVariable.connection.inputs.nodes.find(input => input.key === 'password');

      if (!username || !password) {
        throw new Error('Username and password inputs not found');
      }

      const values = {
        username: ref(store.getConnectionConfigVariable(key, 'username')),
        password: ref(store.getConnectionConfigVariable(key, 'password')),
      };

      const allFilledUp = computed(() => values.username.value && values.password.value);

      const submit = () => {
        if (!allFilledUp.value) {
          return;
        }

        store.setConnectionConfigVariable(key, 'username', values.username.value!);
        store.setConnectionConfigVariable(key, 'password', values.password.value!);
        store.nextStep();
      };

      return {
        username,
        password,
        values,
        submit,
        allFilledUp,
      };
    },
  });
